/// <reference types="vite/client" />
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://b8e39da084feffe87b3e7ccf1948736e@o4511312414113792.ingest.us.sentry.io/4511312416276480',
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
});
